import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getChargesDetailsFleet, getChargesDetailsFleetSuccess, getDossierDetailsFleet } from '../../../../actions/management/management'
import { openModal } from '../../../../actions/common'
import { openDocumentEditionModal, openDocumentEditionModalFleet } from '../../../../actions/dossier/common/documentEditionModal'
import { openChargeDetailsModal } from '../../../../actions/management/auxModals/auxModals'
import ChargeFleetListComponent from '../../../../components/management/fleets/data/ChargeFleetListComponent'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.management.chargeFleetComponent,
    dossierFleetDetails: state.management.dossierFleetDetails
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openModal,
      getChargesDetailsFleet,
      getChargesDetailsFleetSuccess,
      getDossierDetailsFleet,
      openDocumentEditionModal,
      openDocumentEditionModalFleet,
      openChargeDetailsModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(ChargeFleetListComponent, true)))
